// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"0297625d","551":"bb49b5fb","579":"9d20922f","770":"45337985"}[chunkId] + ".chunk.css";
};